module.exports = __webpack_public_path__ + "static/media/canada-flag.91badea5.png";